export const ContactAddToDistributionModal: string = 'ContactAddToDistributionModal';
